import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_BASE_HREF, CurrencyPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { MatNativeDateModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatBadgeModule } from '@angular/material/badge';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { AppComponent } from './app.component';

import { DxReportViewerModule } from 'devexpress-reporting-angular';

import { SidebarModule } from './Template/sidebar/sidebar.module';
import { FooterModule } from './Template/shared/footer/footer.module';
import { NavbarModule } from './Template/shared/navbar/navbar.module';
import { FixedpluginModule } from './Template/shared/fixedplugin/fixedplugin.module';
import { AdminLayoutComponent } from './Template/layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './Template/layouts/auth/auth-layout.component';

import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppRoutes } from './app.routing';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { environment } from '../environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule, SERVICE_WORKER, VAPID_KEY } from '@angular/fire/compat/messaging';

import { NgxMaskModule, IConfig } from 'ngx-mask'
import { JwtModule, JWT_OPTIONS } from "@auth0/angular-jwt";
import { NgxPermissionsModule } from 'ngx-permissions';
import { AuthService } from './generics/services/auth.service';
import { ReportViewerComponent } from './generics/components/report-viewer/report-viewer.component';
import { AppService } from './global/services/app.service';
import { InthttpInterceptor } from './global/interceptor/inthttp.interceptor';
export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

export function jwtOptionsFactory(authService: AuthService) {
    return {
        tokenGetter: () => authService.interceptorJWT(),
        allowedDomains: [environment.apiDomain],
        disallowedRoutes: [
            environment.apiUri + "/Auth/Login",
            environment.apiUri + "/Auth/Token"
        ],
    };
}


@NgModule({
    exports: [
        MatAutocompleteModule,
        MatButtonToggleModule,
        MatCardModule,
        MatChipsModule,
        MatCheckboxModule,
        MatStepperModule,
        MatDialogModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatSelectModule,
        MatDatepickerModule,
        MatButtonModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        MatNativeDateModule,
        MatFormFieldModule,
        MatBadgeModule,
        DragDropModule,
        TranslateModule,
    ],
    declarations: [
  ]
})

export class MaterialModule { }

@NgModule({
    imports: [
        DxReportViewerModule,
        CommonModule,
        BrowserAnimationsModule,
        FormsModule,
        NgxMaskModule.forRoot(),
        RouterModule.forRoot(AppRoutes, {
            useHash: false
        }),
        NgxPermissionsModule.forRoot(),
        HttpClientModule,
        JwtModule.forRoot({
            jwtOptionsProvider: {
                provide: JWT_OPTIONS,
                useFactory: jwtOptionsFactory,
                deps: [AuthService]
            }
        }),
        MaterialModule,
        SidebarModule,
        NavbarModule,
        FooterModule,
        FixedpluginModule,
        // ServiceWorkerModule.register('ngsw-worker.js', {
        //   enabled: environment.production,
        //   // registrationStrategy: 'registerImmediately'
        //   registrationStrategy: 'registerWhenStable:30000'
        // }),
        AngularFireModule.initializeApp(environment.firebase),
        AngularFireMessagingModule,
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        })
    ],
    declarations: [
        AppComponent,
        AdminLayoutComponent,
        AuthLayoutComponent,
        ReportViewerComponent
    ],
    providers: [
        AuthService,
        MatNativeDateModule,
        CurrencyPipe,
        AppService,
        { provide: VAPID_KEY, useValue: environment.vapidKey },
        //{ provide: SERVICE_WORKER, useFactory: () => typeof navigator !== 'undefined' && navigator.serviceWorker?.register('firebase-messaging-sw.js', { scope: '__' }) || undefined },
        { provide: HTTP_INTERCEPTORS, useClass: InthttpInterceptor, multi:true}

    ],
    bootstrap: [AppComponent]
})

export class AppModule { }

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

